import React from 'react';
import Profile from "../../../components/pages/form/Profile/Profile";

const ProfilePage = () => {
    return <Profile />
};

export default ProfilePage;